"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagIO = function FlagIO(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,89.86c-20.5,0-20.5-7.06-41-7.06s-20.5,7.06-41,7.06-20.49-7.06-41-7.06-20.47,7.06-40.94,7.06-20.48-7.06-41-7.06-20.48,7.06-40.95,7.06-20.48-7.06-41-7.06-20.47,7.06-40.95,7.06-20.47-7.06-40.93-7.06-20.46,7.06-40.92,7.06V68.68c20.46,0,20.46-7.07,40.92-7.07s20.46,7.07,40.93,7.07,20.48-7.07,41-7.07,20.48,7.07,41,7.07,20.47-7.07,41-7.07,20.48,7.07,41,7.07,20.47-7.07,40.94-7.07,20.49,7.07,41,7.07,20.5-7.07,41-7.07,20.51,7.07,41,7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,5.12c-20.5,0-20.5-7.07-41-7.07s-20.5,7.07-41,7.07-20.49-7.07-41-7.07S73.14,5.12,52.67,5.12s-20.48-7.07-41-7.07S-8.77,5.12-29.24,5.12s-20.48-7.07-41-7.07-20.47,7.07-40.95,7.07-20.47-7.07-40.93-7.07S-172.54,5.12-193,5.12V-16.07c20.46,0,20.46-7.06,40.92-7.06s20.46,7.06,40.93,7.06,20.48-7.06,41-7.06,20.48,7.06,41,7.06,20.47-7.06,41-7.06,20.48,7.06,41,7.06,20.47-7.06,40.94-7.06,20.49,7.06,41,7.06,20.5-7.06,41-7.06,20.51,7.06,41,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-37.25c-20.5,0-20.5-7.07-41-7.07s-20.5,7.07-41,7.07-20.49-7.07-41-7.07-20.47,7.07-40.94,7.07-20.48-7.07-41-7.07-20.48,7.07-40.95,7.07-20.48-7.07-41-7.07-20.47,7.07-40.95,7.07-20.47-7.07-40.93-7.07-20.46,7.07-40.92,7.07V-58.44c20.46,0,20.46-7.06,40.92-7.06s20.46,7.06,40.93,7.06,20.48-7.06,41-7.06,20.48,7.06,41,7.06,20.47-7.06,41-7.06,20.48,7.06,41,7.06S73.14-65.5,93.61-65.5s20.49,7.06,41,7.06,20.5-7.06,41-7.06,20.51,7.06,41,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-79.63c-20.5,0-20.5-7.06-41-7.06s-20.5,7.06-41,7.06-20.49-7.06-41-7.06-20.47,7.06-40.94,7.06-20.48-7.06-41-7.06-20.48,7.06-40.95,7.06-20.48-7.06-41-7.06-20.47,7.06-40.95,7.06-20.47-7.06-40.93-7.06-20.46,7.06-40.92,7.06v-21.18c20.46,0,20.46-7.06,40.92-7.06s20.46,7.06,40.93,7.06,20.48-7.06,41-7.06,20.48,7.06,41,7.06,20.47-7.06,41-7.06,20.48,7.06,41,7.06,20.47-7.06,40.94-7.06,20.49,7.06,41,7.06,20.5-7.06,41-7.06,20.51,7.06,41,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,47.49c-20.5,0-20.5-7.06-41-7.06s-20.5,7.06-41,7.06-20.49-7.06-41-7.06-20.47,7.06-40.94,7.06-20.48-7.06-41-7.06-20.48,7.06-40.95,7.06-20.48-7.06-41-7.06-20.47,7.06-40.95,7.06-20.47-7.06-40.93-7.06-20.46,7.06-40.92,7.06V26.3c20.46,0,20.46-7.06,40.92-7.06s20.46,7.06,40.93,7.06,20.48-7.06,41-7.06,20.48,7.06,41,7.06,20.47-7.06,41-7.06,20.48,7.06,41,7.06,20.47-7.06,40.94-7.06,20.49,7.06,41,7.06,20.5-7.06,41-7.06,20.51,7.06,41,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,132.23c-20.5,0-20.5-7.06-41-7.06s-20.5,7.06-41,7.06-20.49-7.06-41-7.06-20.47,7.06-40.94,7.06-20.48-7.06-41-7.06-20.48,7.06-40.95,7.06-20.48-7.06-41-7.06-20.47,7.06-40.95,7.06-20.47-7.06-40.93-7.06-20.46,7.06-40.92,7.06V111.05c20.46,0,20.46-7.07,40.92-7.07s20.46,7.07,40.93,7.07,20.48-7.07,41-7.07,20.48,7.07,41,7.07,20.47-7.07,41-7.07,20.48,7.07,41,7.07S73.14,104,93.61,104s20.49,7.07,41,7.07,20.5-7.07,41-7.07,20.51,7.07,41,7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74,12.18H-185.94A7.06,7.06,0,0,1-193,5.12V-114.94a7.06,7.06,0,0,1,7.06-7.06H4.74a7.06,7.06,0,0,1,7.06,7.06V5.12a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.3v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.48v5.6a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.48L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122H-101.2v56.5H-193v21.18h91.8v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.23a6.94,6.94,0,0,0-3.37,5.86v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M117.73,117.29a4.89,4.89,0,0,1-4.89-4.89V-44h9.78V112.4a4.89,4.89,0,0,1-4.89,4.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M186.18-24.49l-9.78-4.88-36-4.5,22.27-28.64,3.46-10.37-10.37,3.45L127.12-47.15l-4.5-36-4.89-9.78-4.89,9.78-4.5,36L79.7-69.43,69.34-72.88l3.45,10.37L95.07-33.87l-36,4.5-9.78,4.88,9.78,4.89,36,4.5L72.79,13.54,69.34,23.91,79.7,20.45l31.12-24.2,6.91-11,6.91,11,31.12,24.2,10.37,3.46-3.46-10.37L140.4-15.1l36-4.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M139,32.45c-4.4-4.38-13.81-2.77-18.84-1.5v-4.1a2.45,2.45,0,1,0-4.89,0V31c-5-1.28-14.45-2.89-18.84,1.5-4.19,4.19-1.16,14.29,1.73,21.31v6.5a3.24,3.24,0,0,0,3.25,3.25H134a3.26,3.26,0,0,0,3.26-3.25v-6.5c2.88-7,5.91-17.12,1.73-21.31Zm-3.46,3.46c1.87,1.87-.23,10.05-3.6,17.82H120.18V36c5.48-1.55,13-2.47,15.38-.09Zm-35.66,0c2.38-2.38,9.9-1.46,15.39.09V53.73H103.5C100.13,46,98,37.78,99.9,35.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagIO;
exports["default"] = _default;